import * as moment from 'moment';
import * as _ from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { DonorShieldContext } from './context';
import { IWatrRequest, IWatrReimbursement } from '@nkr/models/index';
import { FileDocumentType } from '@nkr/enums/document-type';
import { downloadFile } from '@nkr/services/download-file';
import { PanelGroup } from 'react-bootstrap';
import { toast } from 'react-toastify';
import TravelReimbursementRecord from './travel-reimbursement-record';
import WatrInfoAccordions from './accordion';
import Header from './header';
import { CompactBankingRow } from './common/compact-banking-row';
import './verify/components/reimbursement-verify.css';

interface IProps {
    data: IWatrRequest,
    isAudit: boolean,
    reimbursements: IWatrReimbursement[],
}

const ReimburseExpenses = (props: IProps) => {
    const context = useContext(DonorShieldContext);
    const [bankingRevealed, setBankingRevealed] = useState(false);

    const handleDownloadFile = (docType: FileDocumentType, lookupId: number) => {
        context.downloadFile(docType, lookupId)
            .then((response: any) => {

                let fileName = props.data.firstName + '_' + props.data.lastName
                    + "_" + FileDocumentType[docType].toString()
                    + "_" + moment().format("YYYY_MM_DD");

                downloadFile(response.data, fileName, response.data.type);
            })
            .catch((e: any) => {
                const msg = e?.response?.data?.message || e?.message || 'Unable to download file.';
                toast.error(msg);
            });
    };

    let travels = _.sortBy(props.data.requestTravels, item => item.createdDateTime);

    useEffect(() => {
        setBankingRevealed(false);
    }, [props.data.id]);

    return (
        <>
            <div>
                <Header data={props.data} showStatus={false} />

                <div className='reimbursement-verify'>
                    <div className='page-header' style={{ marginTop: 10 }}>
                        <span className='page-title'>Record Expense Payments</span>
                        <span className='page-note'>Log ACH confirmations for approved travel expense claims.</span>
                    </div>
                </div>

                <PanelGroup style={{ paddingTop: 10 }}>
                    {travels.map((travel) =>
                        <TravelReimbursementRecord
                            data={travel}
                            downloadFile={handleDownloadFile} />
                    )}
                </PanelGroup>

                <hr />

                <CompactBankingRow
                    data={props.data}
                    bankingRevealed={bankingRevealed}
                    onToggleBankingRevealed={() => setBankingRevealed(v => !v)}
                    variant="boxed"
                    showPaymentLabel={false}
                />

                <WatrInfoAccordions
                    data={props.data}
                    isAudit={props.isAudit}
                    reimbursements={props.reimbursements}
                    paymentWorkflow='expenses'
                    reimbursementType={props.data.watrRequestType}
                />
            </div>
        </>
    );
}

export default ReimburseExpenses;
